export function scrollToElement(element, offset = 0) {
    if (!element)
        return;
    const yOffset = offset;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
}
